//
//
//
//
//

export default {
	mounted(){
		this.$store.dispatch('setIndex',3);
	}
}



// WEBPACK FOOTER //
// ./src/views/singer.vue